import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';

import Icons from 'consts/icons';
import PopupLoader from 'components/common/PopupLoader';
import { setLanguage } from 'store/actions/language/language';
import { useLoginStyles } from 'consts/styles/Login';

import ButtonsUseStyles from 'consts/styles/Buttons';
import Copyright from './Copyright';
import SignIn from './SignIn';
import SetPassword from './SetPassword';
import PasswordReset from './PasswordReset';

const LoginPage = props => {
  const { history } = props;
  const [siteLang, setSiteLang] = React.useState('en');
  const [seeableLoader, setSeeableLoader] = React.useState(false);
  const [type, setType] = React.useState('login');

  const dispatch = useDispatch();

  const changeLanguage = () => {
    const langToShow = siteLang === 'pl' ? 'en' : 'pl';
    setSiteLang(langToShow);
    dispatch(setLanguage(langToShow));
  };

  const classes = useLoginStyles();
  const classesButtons = ButtonsUseStyles();

  const handleSwitch = () => {
    switch (type) {
      case 'login':
        return (
          <SignIn
            siteLang={siteLang}
            setSeeableLoader={setSeeableLoader}
            history={history}
            dispatch={dispatch}
            setType={setType}
          />
        );
      case 'reset':
        return (
          <PasswordReset
            siteLang={siteLang}
            history={history}
            dispatch={dispatch}
            setType={setType}
          />
        );
      case 'setpass':
        return (
          <SetPassword
            siteLang={siteLang}
            history={history}
            dispatch={dispatch}
            setType={setType}
          />
        );
      default:
        return 0;
    }
  };

  const init = () => {
    setType('login');
  };

  React.useEffect(init, []);

  return (
    <div className={classes.Login}>
      {seeableLoader && <PopupLoader />}
      <Button
        className={`${classes.Login}__lang ${classesButtons.ButtonsClose}--login-page ${classesButtons.ButtonsClose} ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}`}
        onClick={() => changeLanguage()}
      >
        <Icons.Misc.Language className={`${classes.Login}__lang__icon`} />
        &nbsp;&nbsp;
        <div className={`${classes.Login}__lang__text`}>
          {siteLang === 'pl' ? 'PL' : 'EN'}
        </div>
      </Button>
      <Container
        className={`${classes.Login}__container`}
        component="main"
        maxWidth="xs"
      >
        <CssBaseline />
        <div className={`${classes.Login}__container__paper`}>
          <Avatar
            className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}`}
          >
            <Icons.Misc.LocalAirport />
          </Avatar>
          {handleSwitch()}
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Container>
    </div>
  );
};

LoginPage.propTypes = {
  history: PropTypes.object,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(LoginPage);
